export enum DealStage {
  WON = 'dealStageWon',
  PENDING = 'dealStagePending',
  LOST = 'dealStageLost',
  DELEGATE = 'dealStageDelegated',
  BLOCKED = 'dealStageBlocked',
}
